import { post} from './index'
export default {
 // 意见反馈
 addOrUpdateFeedback: (params) => post('feedback/addOrUpdateFeedback', params),

 // 商务合作
 addOrUpdateCooperationApply: (params) => post('CooperationApply/addOrUpdateCooperationApply', params),
};
